import React, { useState, useEffect } from 'react';
import { FileText, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

export default function ContractsPage() {
  const { api } = useAuth();
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('get', '/api/admin/contracts').then(r => setContracts(r.data.contracts || [])).finally(() => setLoading(false));
  }, []);

  const total = contracts.filter(c => c.status === 'active').reduce((s, c) => s + parseFloat(c.price || 0), 0);

  return (
    <div className="max-w-5xl">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Contracten</h1>
        <Link to="/admin/clients" className="flex items-center gap-2 bg-[#D4A017] hover:bg-[#B8860B] text-[#0f172a] font-bold px-4 py-2 rounded-xl text-sm">
          <Plus size={16} /> Via klantpagina
        </Link>
      </div>
      <div className="bg-[#D4A017]/10 border border-[#D4A017]/20 rounded-xl px-6 py-4 mb-6">
        <p className="text-[#94a3b8] text-xs uppercase tracking-wider">Totale maandelijkse omzet</p>
        <p className="text-white font-bold text-2xl">€{total.toLocaleString('nl-NL')}/maand</p>
      </div>
      <div className="bg-[#0f172a] rounded-2xl border border-white/5 overflow-hidden">
        <div className="grid grid-cols-5 text-xs font-bold text-[#475569] uppercase px-5 py-3 border-b border-white/5">
          <span className="col-span-2">Klant / Dienst</span><span>Prijs</span><span>Looptijd</span><span>Status</span>
        </div>
        {loading ? <div className="py-8 text-center"><div className="w-6 h-6 border-2 border-[#D4A017] border-t-transparent rounded-full animate-spin mx-auto" /></div>
        : contracts.length === 0 ? <div className="py-8 text-center text-[#475569]">Geen contracten</div>
        : contracts.map(c => (
          <Link key={c.id} to={`/admin/clients/${c.company_id}`} className="grid grid-cols-5 items-center px-5 py-4 hover:bg-white/5 border-b border-white/5 last:border-0 transition-all">
            <div className="col-span-2">
              <p className="text-white text-sm font-medium">{c.company_name}</p>
              <p className="text-[#475569] text-xs">{c.service}</p>
            </div>
            <span className="text-[#D4A017] font-bold text-sm">€{c.price}/mnd</span>
            <span className="text-[#64748b] text-sm">{c.duration} mnd</span>
            <span className={`text-xs px-2 py-1 rounded-full w-fit ${c.status === 'active' ? 'bg-green-500/20 text-green-400' : 'bg-[#475569]/20 text-[#94a3b8]'}`}>
              {c.status === 'active' ? 'Actief' : c.status}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
